export default defineNuxtPlugin((nuxtApp) => {
	const router = nuxtApp.$router

	router.options.scrollBehavior = (to, from, savedPosition) => {
		if (savedPosition) return savedPosition
		if (to.hash) {
			return new Promise((resolve) => {
				setTimeout(() => {
					const el = document.querySelector(to.hash)
					if (el) el.scrollIntoView({behavior: 'smooth'})
					resolve({left: 0, top: 0})
				}, 50)
			})
		}

		return {left: 0, top: 0}
	}
})
